<template>
    <el-header>
        <div class="header-left">
            <router-link to="/">
                <img src="./images/Group 3.png" alt="">
            </router-link>
        </div>
        <div class="header-right">
            <div class="doc-link">
                <!-- <a href="https://showdoc.sharecharger.com/web/#/1?page_id=7" target="_Blank">接入指引文档</a> -->
                <a href="https://showdoc.sharecharger.com/web/#/1?page_id=6" target="_Blank">技术指引文档</a>
            </div>
            <div v-if="!hideEmail" class="user-info">
                <div><img src="./images/Group.png" alt=""></div>
                <span>{{email}}</span>
            </div>
            <a v-if="!hideEmail" class="logout" @click="handleLogout">退出</a>
            <router-link v-if="hideEmail" class="logout" to="/login">登录</router-link>
        </div>
    </el-header>
</template>
<script>
import { Message } from "element-ui";
export default {
    data () {
        return {
            email: ''
        }
    },
    props: ['hideEmail'],
    created () {
        this.email = localStorage.getItem('email')
    },
    methods: {
        handleLogout () {
            localStorage.removeItem('token')
            Message.success('退出成功!')
            this.$router.push('/login')
        }
    }
}
</script>
<style lang="scss" scoped>
    @import './scss/top-header.scss';
    .el-header {
        a {
            cursor: pointer;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/top-header.vue